{
  "name": "globe-speaker",
  "version": "2.1.16",
  "scripts": {
    "ng": "ng",
    "start": "npx ng serve --host app.globespeaker.local --port 4200",
    "build": "ng build",
    "build-dev": "ng build --configuration dev",
    "build-staging": "ng build --configuration staging --output-hashing=all",
    "build-prod": "ng build --configuration production --output-hashing=all",
    "build-all": "ng build --configuration dev --output-hashing=all && ng build --configuration staging --output-hashing=all && ng build --configuration production --output-hashing=all",
    "test": "ng test",
    "lint": "ng lint",
    "e2e": "ng e2e",
    "translate": "npx ngx-translate-extract --input ./src --output ./src/assets/i18n/*.json --clean --sort --marker _",
    "translate-en": "npx ngx-translate-extract --input ./src --output ./src/assets/i18n/en.json --clean --sort --marker _",
    "translate-fr": "npx ngx-translate-extract --input ./src --output ./src/assets/i18n/fr.json --clean --sort --marker _",
    "translate-it": "npx ngx-translate-extract --input ./src --output ./src/assets/i18n/it.json --clean --sort --marker _",
    "translate-ru": "npx ngx-translate-extract --input ./src --output ./src/assets/i18n/ru.json --clean --sort --marker _",
    "translate-uk": "npx ngx-translate-extract --input ./src --output ./src/assets/i18n/uk.json --clean --sort --marker _",
    "translate-zh": "npx ngx-translate-extract --input ./src --output ./src/assets/i18n/zh.json --clean --sort --marker _"
  },
  "private": true,
  "dependencies": {
    "@angular/animations": "~20.3.16",
    "@angular/cdk": "~20.0.0",
    "@angular/common": "~20.3.16",
    "@angular/compiler": "~20.3.16",
    "@angular/core": "~20.3.16",
    "@angular/forms": "~20.3.16",
    "@angular/localize": "~20.3.16",
    "@angular/platform-browser": "~20.3.16",
    "@angular/platform-browser-dynamic": "~20.3.16",
    "@angular/platform-server": "~20.3.16",
    "@angular/router": "~20.3.16",
    "@fortawesome/free-brands-svg-icons": "^6.4.0",
    "@fortawesome/free-solid-svg-icons": "^6.4.0",
    "@ng-bootstrap/ng-bootstrap": "^19.0.1",
    "@ngx-pwa/local-storage": "^20.0.0",
    "@ngx-translate/core": "^15.0.0",
    "@ngx-translate/http-loader": "^8.0.0",
    "@popperjs/core": "^2.11.6",
    "aos": "^2.3.4",
    "bootstrap": "^4.5.2",
    "cookieconsent": "^3.1.1",
    "express": "^4.15.2",
    "hanzi-writer": "^3.5.0",
    "highcharts": "^11.0.0",
    "highcharts-angular": "^4.0.0",
    "jquery": "^3.5.1",
    "jwt-decode": "^3.1.2",
    "mobile-drag-drop": "^2.3.0-rc.2",
    "moment-timezone": "^0.5.31",
    "ng-circle-progress": "^1.7.1",
    "ngx-cookieconsent": "^6.0.0",
    "ngx-device-detector": "^10.0.0",
    "ngx-drag-drop": "^20.0.0",
    "ngx-toastr": "^19.0.0",
    "print-js": "^1.6.0",
    "recordrtc": "^5.6.1",
    "rxjs": "~7.8.0",
    "simple-keyboard": "^3.2.8",
    "swiper": "^11.1.14",
    "ts-md5": "^1.2.8",
    "tslib": "^2.0.0",
    "zone.js": "~0.15.0"
  },
  "devDependencies": {
    "@angular-devkit/build-angular": "~20.3.14",
    "@angular/cli": "~20.3.14",
    "@angular/compiler-cli": "~20.3.16",
    "@angular/language-service": "~20.3.16",
    "@types/express": "^4.17.13",
    "@types/highcharts": "^7.0.0",
    "@types/jasmine": "~4.3.0",
    "@types/node": "^18.19.0",
    "@vendure/ngx-translate-extract": "^8.2.2",
    "angular-eslint": "21.0.1",
    "browser-sync": "^3.0.2",
    "eslint": "^9.39.1",
    "jasmine-core": "~4.5.0",
    "jasmine-spec-reporter": "~7.0.0",
    "karma": "~6.4.4",
    "karma-chrome-launcher": "~3.2.0",
    "karma-coverage": "~2.2.0",
    "karma-jasmine": "~5.1.0",
    "karma-jasmine-html-reporter": "~2.1.0",
    "material-icons": "^0.6.4",
    "protractor": "~7.0.0",
    "ts-loader": "^5.2.0",
    "ts-node": "~7.0.0",
    "typescript": "~5.9.3",
    "typescript-eslint": "8.46.4",
    "webpack": "^5.76.0"
  }
}
